@let apiResponse = statusData();
@if (apiResponse && apiResponse.data.length > 0) {
  <div class="text-lg font-medium mb-2">Igangværende jobs</div>
  <div class="mb-4">
    <p-table
      [value]="apiResponse.data"
      [showGridlines]="true"
      stripedRows
      scrollable="true"
      scrollHeight="200px"
      class="p-datatable-sm lp-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Tidspunkt</th>
          <th>Job</th>
          <th>Meddelelse</th>
          <th>Fremgang</th>
          <th>Estimeret slut</th>
          @if (batchService.allowWrite()) {
            <th></th>
          }
        </tr>
      </ng-template>
      <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
        <tr>
          <td class="numbers whitespace-nowrap">
            {{ item.statusTidspunkt | date: 'dd-MM-yyyy HH:mm:ss' }}
          </td>
          <td>
            {{ item.batchJob.batchJobSchedule.jobNavn }}
          </td>
          <td>
            {{ item.igangvaerendeOpgave }}
          </td>
          <td>
            <p-progressbar [value]="item.procentFaerdig" />
          </td>
          <td class="numbers whitespace-nowrap">
            {{
              beregnetSlutTid(item.estimeretRestTid)
                | date: 'dd-MM-yyyy HH:mm:ss'
            }}
          </td>
          @if (batchService.allowWrite() && item.batchJob.status !== 'Failed') {
            <td>
              <p-button
                size="small"
                label="Afbryd"
                icon="pi pi-times-circle"
                severity="danger"
                (click)="onClickAfbryd(item)"></p-button>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}
